export default __webpack_public_path__ + "static/media/deleteTemplate.e453c845.svg";